import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { completeDiscordIntegrationOAuthAPI } from "../lib/api/api";

const DiscordIntegrationOAuth = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();

  useEffect(() => {
    const code = searchParams.get("code");
    const error = searchParams.get("error");
    const errorDescription = searchParams.get("error_description");

    if (error) {
      toast.error(
        errorDescription ||
          "Discord-Verknüpfung konnte nicht abgeschlossen werden."
      );
      navigate("/settings", { replace: true });
      return;
    }

    if (!code) {
      toast.error(
        "Kein Autorisierungscode erhalten. Bitte starte die Verknüpfung erneut."
      );
      navigate("/settings", { replace: true });
      return;
    }

    const finalizeIntegration = async () => {
      try {
        const response = await completeDiscordIntegrationOAuthAPI(code);
        const status = String(response?.status || "").toLowerCase();

        if (status === "success" || status === "authorized") {
          toast.success("Discord erfolgreich verknüpft.");
        } else if (status === "unauthorized") {
          toast.error(
            response?.message ||
              "Die Discord-Verknüpfung wurde abgelehnt. Bitte versuche es erneut."
          );
        } else if (response?.message) {
          toast.info(response.message);
        } else {
          toast.success("Discord-Integration aktualisiert.");
        }

        queryClient.invalidateQueries(["settings", "subscription"]);
        queryClient.invalidateQueries(["settings", "va-access"]);
      } catch {
        // Fehler wurde bereits im API-Layer behandelt.
      } finally {
        navigate("/settings", { replace: true });
      }
    };

    finalizeIntegration();
  }, [searchParams, navigate, queryClient]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bgColor px-4 py-8 text-textTitle">
      <div className="flex flex-col items-center gap-3 rounded-lg border border-borderBottom bg-background px-6 py-8 shadow-sm">
        <i className="bx bx-loader-alt animate-spin text-4xl text-primary"></i>
        <h1 className="text-lg font-semibold">Discord wird verbunden …</h1>
        <p className="text-center text-sm text-textPrimary">
          Bitte warte einen Moment. Du wirst gleich zu den Einstellungen
          weitergeleitet.
        </p>
      </div>
    </div>
  );
};

export default DiscordIntegrationOAuth;
